export default __webpack_public_path__ + "static/media/banner-top-mb2.ce3ad71e.png";